(() => {
    angular
        .module('app.report')
        .factory('Report', ReportService);

    ReportService.$inject = ['$resource'];

    function ReportService($resource) {
        return $resource('/report/:action/:id/:trackpointId', {}, {
            'getCampaignStatus': {
                method: 'GET',
                params: {
                    action: 'getcampaignstatus'
                }
            },
            'getOverviewData': {
                method: 'GET',
                params: {
                    action: 'getoverviewdata'
                }
            },
            'getProfileData': {
                method: 'GET',
                params: {
                    action: 'getprofiledata'
                }
            },
            'getReportData': {
                method: 'GET',
                params: {
                    action: 'getreportdata'
                }
            },
            'getDelivery': {
                method: 'GET',
                params: {
                    action: 'getdelivery'
                }
            },
            'getSupportData': {
                method: 'GET',
                params: {
                    action: 'getsupportdata'
                }
            },
            'getEventData': {
                method: 'GET',
                params: {
                    action: 'geteventdata'
                }
            },
            'getQualityOverview': {
                method: 'GET',
                params: {
                    action: 'getqualityoverview',
                }
            },
            'getQualityTransparency': {
                method: 'GET',
                params: {
                    action: 'getqualitytransparency',
                }
            },
            'getQualityViewability': {
                method: 'GET',
                params: {
                    action: 'getqualityviewability',
                }
            },
            'getQualityGeoCompliance': {
                method: 'GET',
                params: {
                    action: 'getqualitygeocompliance',
                }
            },
        });
    }
})();
